export const designSystemColors = {
  GRAY_GRAY_100: '#F5F5F5',
  GRAY_GRAY_200: '#D2D2D2',
  GRAY_GRAY_300: '#8F8F8F',
  GRAY_GRAY_400: '#717171',
  GRAY_GRAY_500: '#585858',
  GRAY_GRAY_600: '#464646',
  GRAY_GRAY_700: '#3A3A3A',
  GRAY_GRAY_800: '#2E2E2E',
  GRAY_GRAY_900: '#1F1F1F',
  RED_RED_100: '#FFE6E5',
  RED_RED_200: '#FFC8C8',
  RED_RED_300: '#F36C78',
  RED_RED_400: '#C43148',
  RED_RED_500: '#A8253A',
  RED_RED_600: '#952134',
  RED_RED_700: '#7E1B2B',
  RED_RED_800: '#4E171D',
  RED_RED_900: '#2D1415',
  ORANGE_ORANGE_100: '#FFF2E5',
  ORANGE_ORANGE_200: '#FFC18E',
  ORANGE_ORANGE_300: '#F89338',
  ORANGE_ORANGE_400: '#E76E00',
  ORANGE_ORANGE_500: '#BD5A00',
  ORANGE_ORANGE_600: '#A74E00',
  ORANGE_ORANGE_700: '#722800',
  ORANGE_ORANGE_800: '#5D2300',
  ORANGE_ORANGE_900: '#281508',
  YELLOW_YELLOW_100: '#FDF3D8',
  YELLOW_YELLOW_200: '#F6D986',
  YELLOW_YELLOW_300: '#E0B100',
  YELLOW_YELLOW_400: '#D29E00',
  YELLOW_YELLOW_500: '#A57400',
  YELLOW_YELLOW_600: '#755302',
  YELLOW_YELLOW_700: '#4A3300',
  YELLOW_YELLOW_800: '#372800',
  YELLOW_YELLOW_900: '#221A05',
  LIME_GREEN_LIME_GREEN_100: '#EBF5D1',
  LIME_GREEN_LIME_GREEN_200: '#CCE188',
  LIME_GREEN_LIME_GREEN_300: '#A3C100',
  LIME_GREEN_LIME_GREEN_400: '#91AF00',
  LIME_GREEN_LIME_GREEN_500: '#6E8A00',
  LIME_GREEN_LIME_GREEN_600: '#465900',
  LIME_GREEN_LIME_GREEN_700: '#3A4A00',
  LIME_GREEN_LIME_GREEN_800: '#242E00',
  LIME_GREEN_LIME_GREEN_900: '#171C04',
  VIVID_GREEN_VIVID_GREEN_100: '#E2FCE2',
  VIVID_GREEN_VIVID_GREEN_200: '#9FDEA0',
  VIVID_GREEN_VIVID_GREEN_300: '#47B150',
  VIVID_GREEN_VIVID_GREEN_400: '#27A139',
  VIVID_GREEN_VIVID_GREEN_500: '#009124',
  VIVID_GREEN_VIVID_GREEN_600: '#007511',
  VIVID_GREEN_VIVID_GREEN_700: '#005F07',
  VIVID_GREEN_VIVID_GREEN_800: '#07300C',
  VIVID_GREEN_VIVID_GREEN_900: '#0B1D0C',
  PALE_GREEN_PALE_GREEN_100: '#D0F6E5',
  PALE_GREEN_PALE_GREEN_200: '#78DFAB',
  PALE_GREEN_PALE_GREEN_300: '#00B377',
  PALE_GREEN_PALE_GREEN_400: '#009857',
  PALE_GREEN_PALE_GREEN_500: '#007A42',
  PALE_GREEN_PALE_GREEN_600: '#006334',
  PALE_GREEN_PALE_GREEN_700: '#00522A',
  PALE_GREEN_PALE_GREEN_800: '#00321C',
  PALE_GREEN_PALE_GREEN_900: '#001E12',
  TEAL_TEAL_100: '#CBF6ED',
  TEAL_TEAL_200: '#70E2CD',
  TEAL_TEAL_300: '#00C7A9',
  TEAL_TEAL_400: '#00A68A',
  TEAL_TEAL_500: '#00977B',
  TEAL_TEAL_600: '#007962',
  TEAL_TEAL_700: '#00423A',
  TEAL_TEAL_800: '#00322B',
  TEAL_TEAL_900: '#001E18',
  CYAN_CYAN_100: '#DDF8FE',
  CYAN_CYAN_200: '#B3F0FC',
  CYAN_CYAN_300: '#6CDFF2',
  CYAN_CYAN_400: '#00B0CF',
  CYAN_CYAN_500: '#0090B2',
  CYAN_CYAN_600: '#007391',
  CYAN_CYAN_700: '#004E63',
  CYAN_CYAN_800: '#00303B',
  CYAN_CYAN_900: '#001D22',
  BLUE_BLUE_100: '#EAF5FE',
  BLUE_BLUE_200: '#C0E2FF',
  BLUE_BLUE_300: '#95D0FF',
  BLUE_BLUE_400: '#4797FF',
  BLUE_BLUE_500: '#1865D8',
  BLUE_BLUE_600: '#0F4AA2',
  BLUE_BLUE_700: '#002A69',
  BLUE_BLUE_800: '#02183B',
  BLUE_BLUE_900: '#050C1F',
  INDIGO_INDIGO_100: '#E0E9FF',
  INDIGO_INDIGO_200: '#B9C8FF',
  INDIGO_INDIGO_300: '#8594FF',
  INDIGO_INDIGO_400: '#6C7AF7',
  INDIGO_INDIGO_500: '#5E69E8',
  INDIGO_INDIGO_600: '#3A419E',
  INDIGO_INDIGO_700: '#272D69',
  INDIGO_INDIGO_800: '#1E244D',
  INDIGO_INDIGO_900: '#14172A',
  PURPLE_PURPLE_100: '#EDE5FF',
  PURPLE_PURPLE_200: '#D3C1FF',
  PURPLE_PURPLE_300: '#A581FA',
  PURPLE_PURPLE_400: '#966EED',
  PURPLE_PURPLE_500: '#865ADE',
  PURPLE_PURPLE_600: '#573697',
  PURPLE_PURPLE_700: '#3B2664',
  PURPLE_PURPLE_800: '#2C1F49',
  PURPLE_PURPLE_900: '#1A1529',
  PINK_PINK_100: '#FFE5F7',
  PINK_PINK_200: '#FFB4E2',
  PINK_PINK_300: '#E36AB9',
  PINK_PINK_400: '#D455A9',
  PINK_PINK_500: '#C24098',
  PINK_PINK_600: '#822365',
  PINK_PINK_700: '#581B44',
  PINK_PINK_800: '#411833',
  PINK_PINK_900: '#26121E',
} as const

export type DesignSystemColorToken = keyof typeof designSystemColors

export type DesignSystemColorFamily =
  | 'gray'
  | 'red'
  | 'orange'
  | 'yellow'
  | 'lime-green'
  | 'vivid-green'
  | 'pale-green'
  | 'teal'
  | 'cyan'
  | 'blue'
  | 'indigo'
  | 'purple'
  | 'pink'

export type DesignSystemColorShade =
  | 100
  | 200
  | 300
  | 400
  | 500
  | 600
  | 700
  | 800
  | 900

const familyToTokenPrefix: Record<DesignSystemColorFamily, string> = {
  gray: 'GRAY_GRAY',
  red: 'RED_RED',
  orange: 'ORANGE_ORANGE',
  yellow: 'YELLOW_YELLOW',
  'lime-green': 'LIME_GREEN_LIME_GREEN',
  'vivid-green': 'VIVID_GREEN_VIVID_GREEN',
  'pale-green': 'PALE_GREEN_PALE_GREEN',
  teal: 'TEAL_TEAL',
  cyan: 'CYAN_CYAN',
  blue: 'BLUE_BLUE',
  indigo: 'INDIGO_INDIGO',
  purple: 'PURPLE_PURPLE',
  pink: 'PINK_PINK',
}

export const dsColorVar = (
  family: DesignSystemColorFamily,
  shade: DesignSystemColorShade,
): string => `var(--ds-${family}-${shade})`

export const getDesignSystemColor = (
  family: DesignSystemColorFamily,
  shade: DesignSystemColorShade,
): string => {
  const token =
    `${familyToTokenPrefix[family]}_${shade}` as DesignSystemColorToken
  return designSystemColors[token]
}

export const colorFamilyLabels: Record<DesignSystemColorFamily, string> = {
  gray: 'Gray',
  red: 'Red',
  orange: 'Orange',
  yellow: 'Yellow',
  'lime-green': 'Lime Green',
  'vivid-green': 'Vivid Green',
  'pale-green': 'Pale Green',
  teal: 'Teal',
  cyan: 'Cyan',
  blue: 'Blue',
  indigo: 'Indigo',
  purple: 'Purple',
  pink: 'Pink',
}

export const colorFamilies: DesignSystemColorFamily[] = [
  'gray',
  'red',
  'orange',
  'yellow',
  'lime-green',
  'vivid-green',
  'pale-green',
  'teal',
  'cyan',
  'blue',
  'indigo',
  'purple',
  'pink',
]

export const colorShades: DesignSystemColorShade[] = [
  100, 200, 300, 400, 500, 600, 700, 800, 900,
]
